(ns manage.content-configuration-page.content-configuration.import
  (:require [lemonpi.content-function.shared.macro :refer [parse-macro-expr]]
            [manage.content-configuration-page.context-source.shared
             :refer [context->constructor]]
            [manage.content-configuration-page.placeholder-expression.db
             :refer [value->singular-placeholder-expression]]
            [manage.content-configuration-page.placeholder.db
             :as placeholder]
            [manage.content-configuration-page.rule.db
             :as rule]
            [mate.core :as mc]))

(defn placeholder-expression [override? parent-id
                              {placeholder-name :name value :expr}]
  (let [p (placeholder/tempid parent-id placeholder-name)]
    (cond-> {(if override? :placeholder/_override :placeholder/_default-value) p}
      (string? value)
      (merge (value->singular-placeholder-expression nil value))

      (sequential? value)
      (assoc :collection-placeholder-expression/item
             (for [[item-nr collection-item] (mc/seq-indexed value)]
               {:collection-item/override (map (partial placeholder-expression true p) collection-item)
                :collection-item/order (inc item-nr)})))))

(defn predicate [[operator macro value]]
  (let [{:keys [alias selector]} (first (parse-macro-expr macro))]
    (cond-> {:predicate/operator (keyword operator)
             :context-source/_macro [:context-source/alias (name alias)]
             :macro/selector selector}
      ;; for unary predicates there is no value, and datascript does not accept nil values
      (some? value) (assoc :predicate/value value))))

(defn predicates [ext-predicates]
  (cond
    (true? ext-predicates) []
    (and (sequential? ext-predicates) (= (first ext-predicates) "and"))
    (map predicate (rest ext-predicates))
    :else
    [(predicate ext-predicates)]))

(defn rules [c ext-rules]
  (for [[exec-order {:keys [assignments predicate] rule-name :name}] (mc/seq-indexed ext-rules)
        :let [exec-order (inc exec-order)
              rule-name (or rule-name (str "rule-" exec-order))]]
    {:rule/name rule-name
     :rule/assignment (map (fn [a] (let [phe (placeholder-expression true c a)]
                                     (rule/assignment [:rule/name rule-name] (:placeholder/_override phe) phe)))
                           assignments)
     :rule/execution-order exec-order
     :rule/condition (predicates predicate)}))

(defn placeholder [parent-id idx
                   {placeholder-name :name placeholder-type :type structure :placeholders}]
  (cond-> (assoc (placeholder/->db-placeholder parent-id placeholder-name (keyword placeholder-type))
                 :placeholder/visualization-order (inc idx))
    ;; if this is a collection placeholder, then recursively create the structure
    (not-empty structure)
    (assoc :collection-placeholder/structure (map-indexed (partial placeholder
                                                                   (placeholder/tempid parent-id placeholder-name))
                                                          structure))))

(defn context-source [{:keys [alias schema param] :as context}]
  (if (and (nil? schema) (= alias "custom"))
    ;; automatically convert 'old style' custom context (without reference to
    ;; the Custom schema) to a new style custom context source
    (context-source (assoc context :schema "urn:lemonpi:schema:context:custom:v1"))
    (merge (cond-> {:context-source/schema schema
                    :context-source/alias alias}
             (some? param) (assoc :context-source/original-parameter param))
           (context->constructor context))))

(defn content-configuration [id ext-content-function]
  (let [root-placeholder-parent-id [:content-configuration/id id]]
    (conj (map (partial placeholder-expression false root-placeholder-parent-id)
               (get-in ext-content-function [:data :rules 0 :assignments]))
          {:content-configuration/id id
           :content-configuration/placeholder
           (map-indexed (partial placeholder root-placeholder-parent-id)
                        (get-in ext-content-function [:data :placeholders]))
           :content-configuration/context-source
           (map context-source (get-in ext-content-function [:data :context]))
           :content-configuration/rule
           (rules root-placeholder-parent-id
                  (rest (get-in ext-content-function [:data :rules])))})))
